import { cva } from 'class-variance-authority'
import { Platform } from 'react-native'
import { TypographyVariant } from './types'

const isWeb = Platform.OS === 'web'

export const sTypography = cva('text-text leading-normal', {
  variants: {
    variant: {
      H1: [
        'font-head-heavy',
        // 'leading-none',
        isWeb ? 'text-[4rem]' : 'text-[64px]',
        isWeb ? 'tracking-[0em]' : 'tracking-[-1.6]', // - 2.5%
      ],
      H2: [
        'font-head-heavy',
        // 'leading-none',
        isWeb ? 'text-[3rem]' : 'text-[48px]',
        isWeb ? 'tracking-[0em]' : 'tracking-[-1.2]', // - 2.5%
      ],
      H3: [
        'font-head-heavy',
        // 'leading-none',
        isWeb ? 'text-[2.5rem]' : 'text-[40px]',
        isWeb ? 'tracking-[0em]' : 'tracking-[-1]', // - 2.5%
      ],
      H4: [
        'font-head-heavy',
        // 'leading-none',
        isWeb ? 'text-[2rem]' : 'text-[32px]',
        isWeb ? 'tracking-[0em]' : 'tracking-[-0.8]', // - 2.5%
      ],
      H5: [
        'font-head-heavy',
        // 'leading-none',
        isWeb ? 'text-[1.5rem]' : 'text-[24px]',
        isWeb ? 'tracking-[0em]' : 'tracking-[0]', // 0%
      ],
      H6: [
        'font-head-bold',
        // 'leading-none',
        isWeb ? 'text-[1rem]' : 'text-[16px]',
        isWeb ? 'tracking-[0.025em]' : 'tracking-[0.4]', // + 2.5%
      ],
      XL: [
        'font-text-regular',
        // 'leading-tight',
        isWeb ? 'text-[1.5rem]' : 'text-[24px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.48]', // -2%
      ],
      XLB: [
        'font-text-bold',
        // 'leading-tight',
        isWeb ? 'text-[1.5rem]' : 'text-[24px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.48]', // -2%
      ],
      LG: [
        'font-text-medium',
        // 'leading-tight',
        isWeb ? 'text-[1.25rem]' : 'text-[20px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.4]', // -2%
      ],
      LGB: [
        'font-text-bold',
        // 'leading-tight',
        isWeb ? 'text-[1.25rem]' : 'text-[20px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.4]', // -2%
      ],
      MD: [
        'font-text-medium',
        // 'leading-normal',
        isWeb ? 'text-[1rem]' : 'text-[16px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.32]', // -2%
      ],
      MDB: [
        'font-text-bold',
        // 'leading-normal',
        isWeb ? 'text-[1rem]' : 'text-[16px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.32]', // -2%
      ],
      SM: [
        'font-text-medium',
        // 'leading-normal',
        isWeb ? 'text-[0.875rem]' : 'text-[14px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.28]', // -2%
      ],
      SMB: [
        'font-text-bold',
        // 'leading-normal',
        isWeb ? 'text-[0.875rem]' : 'text-[14px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.28]', // -2%
      ],
      XS: [
        'font-text-medium',
        // 'leading-normal',
        isWeb ? 'text-[0.75rem]' : 'text-[12px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.24]', // -2%
      ],
      XSB: [
        'font-text-bold',
        // 'leading-normal',
        isWeb ? 'text-[0.75rem]' : 'text-[12px]',
        isWeb ? 'tracking-[-0.02em]' : 'tracking-[-0.24]', // -2%
      ],
    },
  },
  defaultVariants: {
    variant: 'MD',
  },
})

export const leadingNone = Platform.select({
  default: 'leading-[0]',
  web: 'leading-[1em]',
})

export const sLeading = (v: TypographyVariant) => {
  if (v === 'H1') return leadingNone
  if (v === 'H2') return leadingNone
  if (v === 'H3') return leadingNone
  if (v === 'H4') return leadingNone
  if (v === 'H5') return leadingNone
  if (v === 'H6') return leadingNone
  if (v === 'XL') return 'leading-tight'
  if (v === 'XLB') return 'leading-tight'
  if (v === 'LG') return 'leading-tight'
  if (v === 'LGB') return 'leading-tight'
  if (v === 'MD') return 'leading-normal'
  if (v === 'MDB') return 'leading-normal'
  if (v === 'SM') return 'leading-normal'
  if (v === 'SMB') return 'leading-normal'
  if (v === 'XS') return 'leading-normal'
  if (v === 'XSB') return 'leading-normal'
  return leadingNone
}
